<template>
  <div class="control">
    <input type="date" ref="calendar" class="input" />
  </div>
</template>

<script>
import { system_settings } from "@/utils";
import bulmaCalendar from "bulma-extensions/bulma-calendar/dist/js/bulma-calendar.min.js";
import "bulma-extensions/bulma-calendar/dist/css/bulma-calendar.min.css";
import moment from "moment";

export default {
  name: "GenericCalendar",
  props: {
    type: {
      type: String,
      required: false,
    },
    display_mode: {
      type: String,
      required: false,
    },
    is_range: {
      type: Boolean,
      default: false,
    },
    minute_steps: {
      type: Number,
      required: false,
      default: 30,
    },
    edit_time_manually: {
      type: Boolean,
      required: false,
      default: false,
    },
    // date_format: {
    //   type: String,
    //   required: false,
    //   default() {
    //     // console.log("system_settings", system_settings);
    //     // if (system_settings && system_settings.enterprise_settings)
    //     // if (this.type == "date")
    //     //   system_settings.enterprise_settings.date_format;
    //     // else if (this.type == "datetime")
    //     //   system_settings.enterprise_settings.date_time_format;
    //     /* else */ return "DD/MM/YYYY";
    //   },
    // },
  },
  data() {
    return {
      calendar_instance: null,
    };
  },
  computed: {
    date_format() {
      let v = this;
      let date_format = "DD/MM/YYYY";
      if (v.type == "datetime")
        if (
          system_settings &&
          system_settings.enterprise_settings &&
          system_settings.enterprise_settings.date_time_format
        )
          date_format = system_settings.enterprise_settings.date_time_format;
        else date_format = "DD/MM/YYYY HH:mm";
      else if (v.type == "date")
        if (
          system_settings &&
          system_settings.enterprise_settings &&
          system_settings.enterprise_settings.date_format
        )
          date_format = system_settings.enterprise_settings.date_format;
        else date_format = "DD/MM/YYYY";
      return date_format;
    },
  },
  methods: {
    clear() {
      let v = this;
      v.calendar_instance.clear();
    },
    set_date(value) {
      let v = this;
      v.calendar_instance.value(moment(value));
    },
    set_time(value) {
      let v = this;
      console.log("calendar_instance", v.calendar_instance);
      v.calendar_instance.time(value);
    },
    init() {
      let v = this;
      var calendars = bulmaCalendar.attach(v.$refs.calendar, {
        type: v.type,
        displayMode: v.display_mode,
        isRange: v.is_range,
        dateFormat: v.date_format,
        minuteSteps: v.minute_steps,
        editTimeManually: v.edit_time_manually,
      });
      v.calendar_instance = calendars[0];

      for (var i = 0; i < calendars.length; i++) {
        calendars[i].on("select", (date) => {
          let dte = date.data.value();
          if (v.is_range) {
            let arr_date_range = dte.split(" - ");
            let start_date = arr_date_range[0];
            let end_date = arr_date_range[1];

            v.$emit("selected", {
              start_date: start_date,
              end_date: end_date,
            });
          } else {
            v.$emit("selected", moment(dte, v.date_format));
          }
        });
      }
    },
  },
  mounted() {
    let v = this;
    v.init();

    // console.log("system_settings", system_settings);
  },
};
</script>

<style></style>
